export const tick = () => `<svg width="17" height="18" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 12.3L9 17L14.5 7" stroke="#403F42" stroke-width="3" stroke-linecap="round" fill="none"/>
  </svg>`;
